import DepositProtectionModal from './DepositProtectionModal';

export default DepositProtectionModal;
